(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cheapmini-newsletter-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    var popup = document.querySelector('[data-cheapmini-newsletter-popup]');
    if (!popup) {
      return;
    }

    var key = 'cheapminiNewsletterPopupClosedAt';
    var expiry = 7 * 24 * 60 * 60 * 1000;
    var panel = popup.querySelector('.cheapmini-newsletter-popup__panel');
    var forced = popup.querySelector('.errors') || popup.querySelector('[role="status"]');

    function getClosedAt() {
      try {
        return Number(window.localStorage.getItem(key)) || 0;
      } catch (error) {
        return 0;
      }
    }

    function setClosedAt() {
      try {
        window.localStorage.setItem(key, String(Date.now()));
      } catch (error) {
        return;
      }
    }

    function openPopup() {
      popup.hidden = false;
      window.setTimeout(function () {
        if (panel) {
          panel.focus();
        }
      }, 50);
    }

    function closePopup() {
      popup.hidden = true;
      setClosedAt();
    }

    Array.prototype.slice.call(popup.querySelectorAll('[data-cheapmini-newsletter-popup-close]')).forEach(function (button) {
      button.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', function (event) {
      if (!popup.hidden && event.key === 'Escape') {
        closePopup();
      }
    });

    if (forced) {
      openPopup();
      return;
    }

    if (getClosedAt() && Date.now() - getClosedAt() < expiry) {
      return;
    }

    window.setTimeout(openPopup, 3500);
  })();
  } catch(e) { console.error(e); }
})();

})();
